import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import removalsActions from "../../../../redux/actions/removals";

import Header from "../../../Shared/Modals/Header";
import Buttons from "./Buttons";
import Content from "./Contents";
import formatDateToUTC from "../../../../helpers/formatDateUtc";
import convertUTCDateToLocalDate from "../../../../helpers/utcToLocalDate";

const initialState = {
  description: "",
  greenPointID: "EMPTY",
  datetimeRemoval: new Date(),
};
export default function AprobeModal() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const removals = useSelector((state) => state.removals);
  const [formData, setFormData] = useState(initialState);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (error) {
      setTimeout(() => setError(false), 1500);
    }
  }, [error]);

  useEffect(() => {
    if (removals.aprobeModal && removals.dataModal) {
      let temp = {};
      removals.dataModal.materials.forEach((material) => {
        temp[material.material] = material.quantity;
      });
      setFormData({
        ...removals.dataModal,
        greenPointID: removals.dataModal.greenPointID._id,
        materials: temp,
      });
    }
  }, [removals.aprobeModal, removals.dataModal]);

  const handleClose = () => {
    dispatch(removalsActions.setAprobeModal(false));
  };

  const checkMaterials = () =>
    Object.keys(formData.materials).reduce(
      (sum, current) => (sum += parseFloat(formData.materials[current])),
      0
    );

  const handleSuccess = () => {
    console.log(formData.datetimeRemoval)
    console.log(new Date())
    console.log(new Date(formData.datetimeRemoval))

    const dateToday = new Date().getTime();
    const dateTimeRemoval = new Date(formData.datetimeRemoval).getTime();

    if (
      formData.greenPointID !== "EMPTY" &&
      formData.description !== "" &&
      dateTimeRemoval <= dateToday &&
      checkMaterials()
    ) {
      const materials = Object.keys(formData.materials).map((material) => {
        return {
          material,
          quantity: formData.materials[material],
        };
      });
      dispatch(
        removalsActions.patchRemovals({
          formData: {
            ...formData,
            materials,
            approver: auth.user._id,
            accepted: true,
            updatedAt: convertUTCDateToLocalDate(new Date())
          },
        })
      );
      setFormData(initialState);
      handleClose();
    } else {
      setError(true);
    }
  };

  return (
    <Dialog
      open={removals.aprobeModal}
      maxWidth="md"
      fullWidth
      onClose={handleClose}
      scroll="body"
    >
      <DialogContent>
        <Header handleClose={handleClose} title="Editar y aprobar registro" type="VIEW" />
        <Content
          error={error}
          formData={formData}
          setFormData={setFormData}
          checkMaterials={checkMaterials}
        />
      </DialogContent>
      <DialogActions>
        <Buttons
          edit={true}
          handleClose={handleClose}
          handleSuccess={handleSuccess}
        />
      </DialogActions>
    </Dialog>
  );
}
